
import {
  Dialog,
  DialogContent,
} from "@/components/fun-ui/Dialog";
import { formatTime } from "@/lib/utils";
import { PlusVipSuccessIcon } from "../fun-ui/icons";
import { MemberLabel } from "../fun-ui/MemberLabel";
import { MemberButton } from "../fun-ui/MemberButton";
import { useUserVip } from "@/stores/appStore";
import { PaymentType } from "@/stores/slices/commonSlice";

export const PaymentUpgradeSuccessAlert = ({
  title,
  paymentType,
  open,
  setOpen = () => { }
}: {
  title: string;
  paymentType?: PaymentType;
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const {
    vipExtra,
  } = useUserVip();
  const memberName = paymentType === 'upgradePlus3x' ? 'Plus 3倍会员' : 'Plus 会员';
  const displayTitle = title || `${memberName}缴费成功`;

  return (
    <Dialog
      open={open}
      onOpenChange={async (open) => {
        setOpen(open);
      }}
    >
      <DialogContent
        className="flex flex-col items-center justify-center max-w-[720px] gap-0 py-10"
        tabIndex={-1}
        onPointerDownOutside={(evt) => {
          evt.preventDefault();
        }}
        onOpenAutoFocus={(evt) => {
          evt.preventDefault();
        }}
      >
        <PlusVipSuccessIcon size={157} />
        <MemberLabel className="text-4xl font-semibold mt-8">{displayTitle}</MemberLabel>
        <div className="text-annotation-foreground text-center mt-5 text-base">
          会员有效期：{formatTime(vipExtra?.expireTime!, 'YYYY年MM月DD日')}<br />
          感谢支持，我们会持续为 {memberName}提供更多功能和权益！
        </div>

        <MemberButton
          size="lg"
          className="w-[210px] mt-9 text-base"
          onClick={() => {
            setOpen(false);
          }}
        >开始使用</MemberButton>
      </DialogContent>
    </Dialog>
  )
}